import {createContext, ReactNode, useContext, useEffect} from 'react';

import {useNavigate} from 'react-router';

import {useViewModelProvider as useKycContext} from '../../ViewModelContext';

import {transformStringWithUnderScores} from './utils/KycTransformSubState';

type ViewModelContextType = {};

const ViewModelContext = createContext<ViewModelContextType | undefined>(
  undefined,
);

export function ViewModelProvider({children}: {children: ReactNode}) {
  const {data} = useKycContext();
  const navigate = useNavigate();

  useEffect(() => {
    const path = transformStringWithUnderScores(data?.subStateInReview || '');
    setTimeout(() => navigate('/onboarding/kyc/in-review/' + path), 350);
  }, [data?.subStateInReview, navigate]);
  return (
    <ViewModelContext.Provider value={{}}>{children}</ViewModelContext.Provider>
  );
}

export function useViewModelProvider() {
  const context = useContext(ViewModelContext);
  if (context === undefined) {
    throw new Error('Kyc In review ViewModelContext is undefined');
  }
  return context;
}
